import { useState, useEffect, useContext, useMemo } from 'react';
import _ from 'lodash';
import { PapsContext } from '../PapsContext';
import { AppTimestampContext } from '../AppTimestampContext';
import { useCacheDataManager } from './cacheDataManager';
import { shouldUseCache } from './useHelpers';
import { DatabaseContext } from '../DatabaseContext';
import { _cacheGroupTypes } from './useTimestamp';

export const useCachedData = ({
  cache_groupType,
  cache_key,
  fetchers = [],
  updateLocalState,
  postProcess,
}) => {

  const cdm = useCacheDataManager()

  const { paps_state } = useContext(PapsContext) ?? {};
  const { pathViews } = paps_state ?? {};

  const { database_fns } = useContext(DatabaseContext) ?? {};
  const { isProdDb } = database_fns ?? {}

  // appTimestampContext
  const appTimestampContext = useContext(AppTimestampContext);
  const { appTimestamp_state } = appTimestampContext ?? {}
  const { timestampInfo } = appTimestamp_state ?? {}
  const { timestamps, timestampsFetched } = timestampInfo ?? {}
  const timestamp_cachGroupType = timestamps?.[cache_groupType]?.[cache_key]

  const [initialized, setInitialized] = useState(false);
  const [currentTimestamps, setCurrentTimestamps] = useState();
  const { currentTimestampSet, currentTimestamp } = currentTimestamps ?? {};

  // Watch timestamps & init current timestamp
  useEffect(() => {
    setInitialized(false);
    console.log('timestamp_cachGroupType', `${cache_groupType}-${cache_key}-${timestamp_cachGroupType}`)
    setCurrentTimestamps({
      currentTimestampSet: true,
      currentTimestamp: timestamp_cachGroupType
    });
  }, [cache_groupType, cache_key, timestamp_cachGroupType]);

  useEffect(() => {
    if (isProdDb) {
      setInitialized(false);
    }
  }, [isProdDb]);

  useEffect(() => {

    if (!isProdDb) {
      if (!database_fns || !cache_key || initialized || !timestampsFetched || !currentTimestampSet) {
        return;
      }
    }

    setInitialized(true);

    (async () => {

      // Try cache
      const cached = await cdm.getSubItem(cache_groupType, cache_key);

      console.log('✅ cached', `${cache_groupType}-${cache_key}`, `TSinCache:${cached?._timestamp}-TSfromDB:${currentTimestamp}`)

      console.log('isProdDb', isProdDb)

      if (!isProdDb && !_.isEmpty(cached) && shouldUseCache(cached?._timestamp, currentTimestamp, cache_groupType, timestamp_cachGroupType)) {
        console.log('✅')
        updateLocalState(cached);
        return;
      }

      console.log('👉')

      // Helper to fetch one key
      const fetchAndGet = async ({ key, getConfigFn }) =>
        new Promise((resolve, reject) => {
          try {
            const callback = (data) => resolve([key, _.cloneDeep(data)]);
            database_fns.get_data(getConfigFn(pathViews, callback));
          } catch (err) {
            reject(err);
          }
        });

      try {
        const results = await Promise.all(
          fetchers.map(fetchAndGet)
        );

        const mergedData = _(results)
          .compact()
          .fromPairs()
          .pickBy((v) => !_.isNil(v) && !_.isEmpty(v))
          .value();

        let _mergedData = mergedData;

        // ammend the merged data with a parent function
        if (typeof postProcess === 'function') {
          _mergedData = postProcess(_.cloneDeep(mergedData)) ?? mergedData;
        }

        console.log('_mergedData', _mergedData)

        if (!isProdDb) {
          // add the data to the cachDataManages
          await cdm.mergeToGroup(cache_groupType, cache_key, _mergedData, null, true);
        }
        updateLocalState(_mergedData);

      } catch (err) {
        console.error('❌ Failed to fetch cached remote data', err);
      }


    })();

  }, [cache_groupType, cache_key, database_fns, currentTimestamp, currentTimestampSet, timestampsFetched, isProdDb]);

  return { initialized };

};
